import React, {Component} from 'react'
import {Switch, List, Row, Col, message} from 'antd';
import Helmet from "react-helmet";
import Logo from '../../assets/images/mobile-logo.png'
import ajax from "../../api/ajax";
import {baseUrl} from '../../api'
import queryString from "query-string"
import wx from "./images/wx.png"
import subCode from './images/subcode.png'
import successSet from './images/success-set.png'
import errSet from './images/err-set.png'
import './subscribe.less'

const redirect_url = window.location.origin+"/crm/sub?";
const wx_ser_url= baseUrl.split("/").slice(0,3).join("/")+"/wechat"
//const wx_ser_url= "http://jewx.frp.gie360.com"+"/wechat"
const wx_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx239460a0813ea627&redirect_uri="
class Subscribe extends Component {
    state={
        token:null,
        openid:null,
        sub:null,
        nickname:null,
        msg:null,
        subInfo:{},
        subList:[],
        status:""
    }
    subInfo={}

    getSubStr=(subInfo)=>{
        if(subInfo.type ==="user"){
            return "用户"+subInfo.value
        }else if(subInfo.type ==="all"){
            return "所有订单"
        }
    }
    getWxUrl=()=>{
        let catUrl=""
        let wx_redirect_url = redirect_url
        if (JSON.stringify(this.subInfo) !== '{}' && this.subInfo.type){
            catUrl=queryString.stringify(this.subInfo)
        }
        wx_redirect_url = encodeURIComponent(wx_redirect_url+catUrl)
        wx_redirect_url = wx_url+wx_redirect_url+"&response_type=code&scope=snsapi_base&state=a#wechat_redirect"

        return wx_redirect_url
    }
    gotoWx=()=>{
        window.location.href = this.getWxUrl()
    }
    getToken=(code)=>{
        //return null;
        let result = ajax(wx_ser_url+"/token?code="+code);
        result.then((resp)=>{
            if(resp && resp.token){
                this.setState({
                    token:resp.token.accessToken,
                    openid:resp.token.openid,
                },()=>{
                    window.localStorage.setItem("token",this.state.token)
                    window.localStorage.setItem("openid",this.state.openid)
                })
            }
            if(resp&& resp.user){
                this.setState({
                    openid:resp.user.openid,
                    sub:resp.user.subscribe,
                    nickname:resp.user.nickname
                })
            }

            if(resp && resp.user && resp.user.subscribe!==1){
                this.doCheckSub();
            }else if(resp && resp.user && resp.user.subscribe===1){
                this.doSuccess()
            }
            if(!resp || !resp.user){
                this.wxReset();
                this.setState({
                    msg:"发生错误，请重新扫码"
                })
            }
            let query = queryString.parse(this.props.location.search)
            if(query&& query.code){
                delete query.code;
                delete query.state;
                this.props.history.replace("/sub?"+queryString.stringify(query))
            }
        })
    }
    getUserInfo=()=>{
        let token = window.localStorage.getItem("token");
        let openId = window.localStorage.getItem("openid");
        if (token && openId) {
            this.checkToken(token, openId)
        } else {
            //alert(redirect_url+orderNo)
            this.gotoWx()
        }
    }
    getSubList=()=>{
        this.props.history.replace("/sublist")
        let result = ajax(baseUrl+"/d/public/subscribes",{openid:this.state.openid,token:this.state.token});
        result.then((resp)=>{
            if(resp&&resp.code===400){
                this.setState({
                    msg:resp.message+"，请重新扫码"
                })
                this.wxReset();
            }else{
                this.setState({
                    subList:resp.data,
                    status:"订阅清单："
                })
            }
        }).catch(()=>{
            this.setState({
                subList:[]
            })
        })
    }
    doCheckSub=()=>{
        setTimeout(this.getUserInfo,2000)
    }
    doSuccess=()=>{
        if (JSON.stringify(this.subInfo) !== '{}' && this.subInfo.type){
            this.doSub(this.subInfo)
        }else{
            this.getSubList()
        }
    }
    doSub=(subInfo)=>{
        let data = new FormData();
        let post=false
        if(Number.isInteger(subInfo)){
            data.append("id",subInfo)
            post=true
        }else{
            let type = subInfo.type
            let value= subInfo.value
            if(type && value) {
                data.append("openid", this.state.openid)
                data.append("token", this.state.token)
                data.append("type", type)
                data.append("value", value)
                post=true
            }
        }

        if(post){
            let result = ajax(baseUrl+"/d/public/subscribe",data,"POST");
            result.then((resp)=>{
                if (resp && resp.code === 201) {
                    message.info("订阅成功")
                    //this.props.history.replace("/sub")
                } else if(resp && resp.code === 400){
                    message.error(resp.message)
                    this.wxReset();
                }
            }).finally(()=>{
                this.getSubList()
            })
        }
    }
    doUnsub=(id)=>{
        let data = {};
        if(Number.isInteger(id)) {
            data = {
                openid:this.state.openid,
                token: this.state.token,
                id:id,

            }
            let result = ajax(baseUrl + "/d/public/subscribe", data, "DELETE");
            result.then((resp) => {
                if (resp && resp.code === 400) {
                    message.error(resp.message)
                    this.wxReset();
                } else {
                    message.info("取消订阅成功")
                }
            }).finally(() => {
                this.getSubList()
            })
        }
    }
    checkToken=(token,openId)=>{
        let url=wx_ser_url+"/token/check?token="+token+"&openid="+openId
        let result = ajax(url);
        result.then((resp) =>{
            if(resp.user&&resp.user.openid) {
                if(resp.user.subscribe!==1){
                    this.doCheckSub()
                }else if (resp.user.subscribe===1){
                    this.doSuccess()
                }
                this.setState({
                    token:token,
                    openid:resp.user.openid,
                    sub:resp.user.subscribe,
                    nickname:resp.user.nickname
                })
            }else{
                this.gotoWx()
            }
        }, function(error) {
            this.gotoWx()
        });
    }
    wxReset=()=>{
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("openid")
    }
    componentWillMount() {
        this.wxReset()
        let query = queryString.parse(this.props.location.search)
        let code = query.code;
        this.subInfo = query

        if(this.subInfo){
            this.setState({
                subInfo:this.subInfo
            })
        }
        if(code){
            this.getToken(code);
        }else {
            this.getUserInfo();
        }
    }
    onChange=(checked,id)=>{
        if(checked){
            this.doSub(id)
        }else{
            this.doUnsub(id)
        }
    }
    componentDidMount() {

    }

    render () {
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网铁"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                {/* <div>{this.state.nickname}</div>
                <div>{this.state.orderNo}</div>*/}

                {this.state.msg===null?(this.state.sub===null?
                    <div className='set-content' style={{fontSize:25,textAlign:"center"}}>
                        请稍候...
                    </div>
                    :this.state.sub!==1?
                        <div className='attention'>
                            <div className='attention-bg'>
                                <img src={subCode} alt='subCode'/>
                            </div>
                            <div className='attention-code'>
                                <img src={wx} alt='wx'/>
                            </div>
                        </div>:<div className='set-content'>
                            <div className='set-bg' style={{fontSize:25,textAlign:"center"}}>
                                <img src={successSet} alt='subCode'/>
                                <div style={{color:'#75D554'}}>
                                    {this.state.status}
                                </div>
                                {this.state.subList?
                                    <List
                                        dataSource={this.state.subList}
                                        locale={{emptyText:"暂无订阅"}}
                                    renderItem={item => (
                                    <List.Item key={item.id}>
                                        <Row>
                                            <Col span={18}>
                                                {this.getSubStr(item)}
                                            </Col>
                                            <Col span={6}>
                                            <Switch defaultChecked key={item.id} onChange={(checked)=>{
                                                this.onChange(checked,item.id)
                                            }}/>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                )}
                                    />
                                    :null}
                            </div>

                            {/*<div className='set-info'>*/}
                            {/*    <div className="setItem">*/}
                            {/*        <span className='label'>绑定企业:</span>*/}
                            {/*        <span>佳成国际物流有限公司</span>*/}
                            {/*    </div>*/}
                            {/*    <div className="setItem">*/}
                            {/*        <span className='label'>预警内容:</span>*/}
                            {/*        <span>延时预警</span>*/}
                            {/*    </div>*/}
                            {/*    <div className="setItem">*/}
                            {/*        <span className='label'>绑定日期:</span>*/}
                            {/*        <span>2019-12-10</span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*<div className='set-opt'>*/}
                            {/*    <Button>确定</Button>*/}
                            {/*</div >*/}

                        </div>)
                    :
                    <div className='error-content'>
                        <div className='error-bg'>
                            <img src={errSet} alt='errSet'/>
                        </div>
                        <div className='error-info'>
                            <div className="error-label">
                                失败原因:
                            </div>
                            <div className="error-item">
                                {this.state.msg}
                            </div>
                        </div>
                    </div>
                }
                {/*<div className='error-content'>
                    <div className='error-bg'>
                        <img src={errSet} alt='errSet'/>
                    </div>
                    <div className='error-info'>
                       <div className="error-label">
                           失败原因:
                       </div>
                        <div className="error-item">
                            订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败订阅失败
                        </div>
                    </div>

                </div>*/}
            </div>

        );
    }
}
export default Subscribe